// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + "bf9bb258f46fdc8851b9" + ".chunk.js");